import type { AccountNavItem } from '../components/account-nav/types';

type GetAccountNavItemsOptions = {
  paymentCodEnabled: boolean;
};

export const getAccountNavItems = ({
  paymentCodEnabled,
}: GetAccountNavItemsOptions): AccountNavItem[] => {
  const navItems: AccountNavItem[] = [
    {
      href: '/account',
      label: '會員資料',
      dataTestId: 'overview-link',
      icon: 'UserCircleMini',
      isGroup: false,
    },
    {
      href: '/account/marx-payment-account',
      label: '儲值金紀錄',
      dataTestId: 'marx-payment-account-link',
      icon: 'Cash',
      isGroup: false,
    },
    ...(paymentCodEnabled
      ? [
          {
            href: '/account/marx-cod-refund-balance',
            label: '退貨退款餘額',
            dataTestId: 'marx-cod-refund-balance-link',
            icon: 'CurrencyDollar' as const,
            isGroup: false as const,
          },
        ]
      : []),
    {
      href: '/account/addresses',
      label: '收件地址',
      dataTestId: 'addresses-link',
      icon: 'MapPin',
      isGroup: false,
    },
    {
      label: '訂單紀錄',
      dataTestId: 'orders-toggle',
      icon: 'ListBullet',
      isGroup: true,
      links: [
        {
          dataTestId: 'orders-link',
          href: '/account/orders',
          label: '全部訂單',
        },
      ],
    },
  ];
  return navItems;
};
